import {
  GET_RAYON_DATA,
  GET_GOROD_DATA,
  GET_RAYON_BY_AGENT_DATA,
  GET_GOROD_BY_AGENT_DATA,
} from "../types";

const initialState = {
  rayon: [],
  gorod: [],
};

export const rayonAndRegionReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_RAYON_DATA:
      return (() => ({
        ...state,
        rayon: action.data,
      }))();
    case GET_RAYON_BY_AGENT_DATA:
      return (() => ({
        ...state,
        rayonAgent: action.data,
      }))();
    case GET_GOROD_DATA:
      return (() => ({
        ...state,
        gorod: action.data,
      }))();
    case GET_GOROD_BY_AGENT_DATA:
      return (() => ({
        ...state,
        gorodAgent: action.data,
      }))();
    default:
      return state;
  }
};
